<template>
  <v-dialog v-model="value" max-width="1100" @click:outside="closeModal">
    <v-card flat>
      <v-toolbar flat>
        <v-icon>mdi-tag-outline</v-icon>
        <v-card-title class="ma-0 py-0">
          Price History
        </v-card-title>
        <v-col class="d-inline-flex mx-2">
          <PriceSearchFilters v-model="searchParams"/>
          <v-btn
            class="ml-0"
            :loading="loading"
            :disabled="loading"
            depressed
            style="border-top-left-radius: 0px; border-bottom-left-radius:0px; border: 1px solid #9e9e9e; border-left: 0px;"
            height="40"
            color="accent"
            @click.stop="getPriceHistory">
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="auto" class="ml-auto">
          <v-btn icon @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-toolbar>
      <v-container fluid class="mb-0 pb-0">
        <v-data-table
          :headers="baseHeaders"
          :items.sync="prices"
          :loading="loading"
          item-key="uuid"
          height="440"
          hide-default-footer
          :items-per-page.sync="pageSize"
          fixed-header
          dense>
          <template v-slot:[`item.sale_price`]="{ item }">
            <td class="text-no-wrap">{{item.sale_price ? '$' + item.sale_price.toFixed(2) : '-'}}</td>
          </template>
          <template v-slot:[`item.cost`]="{ item }">
            <td class="text-no-wrap">{{item.cost ? '$' + item.cost.toFixed(2) : '-'}}</td>
          </template>
          <template v-slot:[`item.effective_date`]="{ item }">
            <span v-if="item.effective_date">
              {{ formatDate(item.effective_date) }}
            </span>
          </template>
          <template v-slot:footer>
            <PagingFooter
              :pageSizes="pageSizes"
              :pageSize.sync="pageSize"
              :page="page"
              :disablePrevious="disablePrevious"
              :disableNext="disableNext"
              @previous="previous"
              @next="next">
            </PagingFooter>
          </template>
        </v-data-table>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
// API
import Price from '@/api/price'
// Components
import PagingFooter from '@/components/PagingFooter.vue'
import PriceSearchFilters from '@/components/pricing/PriceSearchFilters.vue'
// Mixins
import { userAccess } from '@/mixins/user-access'
import { displayAlert } from '@/mixins/alert'
import { fullWidthTable } from '@/mixins/table'
export default {
  name: 'PriceHistoryModal',
  data () {
    return {
      from: 0,
      page: 1,
      pageSize: 50,
      pageSizes: [25, 50, 100, 200],
      baseHeaders: [
        { text: 'Effective Date', value: 'effective_date' },
        { text: 'Catalog Name', value: 'catalog_name', sortable: true },
        { text: 'Item Id', value: 'item_id' },
        { text: 'UPC', value: 'upc', sortable: true },
        { text: 'Description', value: 'description', sortable: true },
        { text: 'Qty Per Case', value: 'qty_per_case', sortable: true, align: 'center' },
        { text: 'Pack Size', value: 'pack_size' },
        { text: 'SRP', value: 'sale_price', sortable: true },
        { text: 'Cost', value: 'cost', sortable: true }
      ],
      loading: false,
      prices: [],
      searchParams: {}
    }
  },
  components: { PagingFooter, PriceSearchFilters },
  mixins: [fullWidthTable, userAccess, displayAlert],
  props: ['value'],
  watch: {
    page: {
      handler (newValue) {
        if (newValue > 1) {
          this.from = (newValue * this.pageSize)
          this.getPriceHistory()
        } else {
          this.from = 0
          this.getPriceHistory()
        }
      }
    },
    pageSize: {
      handler () {
        this.getPriceHistory()
      }
    },
    searchParams: {
      handler (newValue) {
        if (newValue) {
          if (this.page > 1) {
            this.page = 1
          }
        }
      },
      deep: true
    }
  },
  async created () {
    this.$store.dispatch('getStores')
    if (this.isRetailer) {
      await this.$store.dispatch('getUserRelatedParties')
    }
    if (sessionStorage.price_search_filters && this.activeSearch) {
      this.searchParams = JSON.parse(sessionStorage.price_search_filters)
    }
  },
  computed: {
    activeSearch () {
      if (sessionStorage.price_search_filters) {
        const stored = JSON.parse(sessionStorage.price_search_filters)
        return Object.keys(stored).some(key => Boolean(stored[key]))
      }
      return false
    },
    disablePrevious () {
      return this.from === 0
    },
    disableNext () {
      return this.prices.length < this.pageSize
    }
  },
  methods: {
    async getPriceHistory () {
      if (!this.searchParams.store_id && this.isRetailer) {
        return this.emitAlert(true, 'warning', 'Please select a store')
      }
      this.loading = true
      let prices = []
      const searchData = this.buildSearchData()
      const params = {limit: this.pageSize, offset: this.from}
      try {
        const data = await Price.getPriceHistory(searchData, params)
        if (data && data.length > 0) {
          prices = data
        }
        this.prices = prices
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    },
    buildSearchData () {
      let params = {}
      if (Object.entries(this.searchParams).length > 0) {
        params = { ...this.searchParams }
      }
      return params
    },
    closeModal () {
      this.$emit('closeDialog')
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pricing/PriceHistoryModal.vue